module.exports = __webpack_public_path__ + "media/images/emblems/Salvan-65f99dcd12774a093c3ae8ea20664225.png";